export const CLASS_NAMES = {
  label: "text-12-18 text-neutral-700 normal-case ",
};

export const HIGHLIGHT_PROPS = {
  highlightClassName: "text-turquoise-300 bg-transparent",
  autoEscape: true,
};
